import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=3e4da9cb&scoped=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=3e4da9cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4da9cb",
  null
  
)

export default component.exports